import React from "react";
import styles from "./ThankYouPanel.module.css";
import { SuccessIcon } from "../icons/icons";

/* Final screen — the former review page, now a thank-you split into two boxes:
   left  = thank-you content + user name
   right = the responses summary (question kicker + selected answer). */
const ThankYouPanel = ({ thankYou, userInfo, summary, onHome }) => (
  <div className={styles.thankWrap}>
    {/* Left — thank-you message */}
    <div className={styles.thankLeft}>
      <div className={styles.successIcon}>
        <SuccessIcon />
      </div>
      <span className={styles.eyebrow}>{thankYou.eyebrow}</span>
      <h2 className={`${styles.heading} ${styles.headingSub}`}>
        {thankYou.heading}
        {userInfo.firstName ? `, ${userInfo.firstName}` : ""}
      </h2>
      <p className={styles.lede}>{thankYou.message}</p>

      {thankYou.nextStep && (
        <div className={styles.nextStep}>
          <h4 className={styles.nextStepTitle}>{thankYou.nextStep.title}</h4>
          <p className={styles.nextStepText}>{thankYou.nextStep.message}</p>
        </div>
      )}
    </div>

    {/* Right — responses summary */}
    <div className={styles.thankRight}>
      <h3 className={styles.summaryTitle}>{thankYou.answersTitle}</h3>
      <div className={styles.summaryList}>
        {summary.map((row, i) => (
          <div key={i} className={styles.summaryRow}>
            <span className={styles.summaryKicker}>{row.kicker}</span>
            <span className={styles.summaryAnswer}>{row.answer || "—"}</span>
          </div>
        ))}
      </div>
    </div>

    {/* Action — below the left content on desktop, below the responses on mobile */}
    {onHome && (
      <div className={styles.thankActions}>
        <button type="button" className={`${styles.btn} ${styles.btnPrimary}`} onClick={onHome}>
         ← Back to home
        </button>
      </div>
    )}
  </div>
);

export default ThankYouPanel;
